import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';
import { Icon, IconName } from '../../atoms/icons';

export interface Props {
  className?: string;
  icon: IconName;
  baseColor: string;
  onClick?: (e) => any;
  backgroundColor?: string;
}

class PrimaryActionBarHomeIcon extends React.Component<Props, any> {
  public render() {
    const { icon, baseColor, onClick, className } = this.props;

    return (
      <div className={`${className} nav-item`} onClick={onClick}>
        <Icon icon={icon} baseColor={baseColor} size={'xl'} />
      </div>
    );
  }
}

export default styled(PrimaryActionBarHomeIcon)`
  width: 4rem;
  height: 4rem;
  min-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  background: ${props => props.backgroundColor};
`;
